import React from "react";
import "./App.css";
import LandingPage from "./LandingPage";
import { Switch, Route, Redirect, Link } from "react-router-dom";
import Layout from "./Layout";
import CssBaseline from "@material-ui/core/CssBaseline";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";

function App(props) {
  const darkTheme = createMuiTheme({
    typography: {
      fontFamily: "DINPro",
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
      fontWeightHeavy: 900,
    },
    palette: {
      primary: {
        // Purple and green play nicely together.
        main: "rgba(45,249,255,1)",
      },
      type: "dark",
    },
  });

  return (
    <div className="App">
      <CssBaseline />
      <ThemeProvider theme={darkTheme}>
        <div className="landingPageGradient gradient" />
        <Link to="/">
          <div className="landingPageLogo" />
        </Link>
        <Switch>
          <Route path="/layout/:id">
            <Layout canvasKit={props.canvasKit} />
          </Route>
          <Route path="/layout">
            <Redirect to="/" />
          </Route>
          <Route path="/">
            <LandingPage />
          </Route>
        </Switch>
      </ThemeProvider>
    </div>
  );
}

export default App;
